module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/missouri-state-university-e3a027b75233fc5f7ceab8948b062281.svg";